import { HIGHLIGHTS } from "@/lib/clinic";
import { CheckCircle2 } from "lucide-react";

const REASONS = [
  "Painless treatment with modern anesthesia and gentle technique",
  "Sterilised, audited equipment in every operatory",
  "Transparent pricing — no hidden surprises",
  "Specialists in-house: ortho, RCT, paediatric & cosmetic",
  "Evening hours & weekend availability — open till 9 pm",
  "Multilingual care — Hindi, English & Urdu spoken",
];

export default function WhyUs() {
  return (
    <section
      id="why"
      data-testid="why-us-section"
      className="py-20 sm:py-24 lg:py-32"
    >
      <div className="container mx-auto px-6 sm:px-8">
        <div className="grid lg:grid-cols-12 gap-10 lg:gap-16 items-center">
          {/* Image side */}
          <div className="lg:col-span-5 order-2 lg:order-1">
            <div className="relative">
              <div className="aspect-[4/5] rounded-[2rem] overflow-hidden bg-stone-100">
                <img
                  src="https://images.unsplash.com/photo-1758205307960-4a0ec7ad2c0e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA3MDB8MHwxfHNlYXJjaHwxfHxkZW50YWwlMjBjbGluaWMlMjBjaGVja3VwJTIwcGF0aWVudHxlbnwwfHx8fDE3Nzc2MzIxNTN8MA&ixlib=rb-4.1.0&q=85"
                  alt="Gentle dental check-up at Dent Square"
                  className="w-full h-full object-cover"
                />
              </div>
              {/* Stat overlay */}
              <div className="absolute -bottom-6 -right-4 bg-[#3A564A] text-[#FAFAF9] rounded-2xl p-5 shadow-xl max-w-[200px]">
                <p className="font-display text-3xl font-bold leading-none">
                  5.0★
                </p>
                <p className="mt-2 text-xs uppercase tracking-[0.18em] opacity-80">
                  on 77 Google reviews
                </p>
              </div>
            </div>
          </div>

          {/* Reasons */}
          <div className="lg:col-span-7 order-1 lg:order-2">
            <span className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-[0.22em] text-[#3A564A]">
              <span className="h-px w-8 bg-[#3A564A]" />
              Why patients choose us
            </span>
            <h2 className="font-display font-bold text-stone-900 text-4xl sm:text-5xl tracking-tight mt-5 leading-[1.05]">
              Treatment that's gentle. Care that's genuine.
            </h2>

            {/* Highlight stats */}
            <div className="mt-8 grid grid-cols-2 sm:grid-cols-4 gap-3">
              {HIGHLIGHTS.map((h) => (
                <div
                  key={h.label}
                  className="rounded-2xl border border-stone-200 bg-white p-4"
                >
                  <p className="font-display text-2xl font-bold text-stone-900">
                    {h.value}
                  </p>
                  <p className="text-xs uppercase tracking-wider text-stone-500 mt-1">
                    {h.label}
                  </p>
                </div>
              ))}
            </div>

            {/* Reasons list */}
            <ul className="mt-8 grid sm:grid-cols-2 gap-x-6 gap-y-3">
              {REASONS.map((r, i) => (
                <li
                  key={i}
                  data-testid={`reason-${i}`}
                  className="flex items-start gap-3 text-stone-700 text-sm leading-relaxed"
                >
                  <CheckCircle2 className="w-5 h-5 text-[#3A564A] shrink-0 mt-0.5" />
                  {r}
                </li>
              ))}
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
}
